import Event from "./Event";

import Wechat from "./wechat";
import DingTalk from "./dingTalk";
import GovDingTalk from "./govDingTalk";
import Native from "./native";
import Android from "./android";
import Ios from "./ios";
import Harmony from "./harmony";
// // import dsf from '../utils';
import miniapp from "./miniapp";

const driveList = {
  miniapp,
  GovDingTalk,
  DingTalk,
  Wechat,
  Harmony,
  Android,
  Ios,
  Native,
};

let sdkMap = null;
function getSdkMap() {
  if (!sdkMap) {
    sdkMap = {
      _dingTalk: {
        sdkUrl:
          "https://g.alicdn.com/dingding/dingtalk-jsapi/2.10.3/dingtalk.open.js",
      },
      _govDingTalk: {
        sdkUrl: "https://g.alicdn.com/gdt/jsapi/1.9.18/index.js",
      },
      _android: {
        sdkUrl: dsf.url.getWebPath("$/js/libs/cordova/android/cordova.js"),
      },
      _ios: {
        sdkUrl: dsf.url.getWebPath("$/js/libs/cordova/ios/cordova.js"),
      },
      _harmony: {
        sdkUrl: dsf.url.getWebPath("$/js/libs/harmony-dreamsoft-sdk/dsfbridge.js"),
      },
      _wechat: {
        sdkUrl: "https://res.wx.qq.com/open/js/jweixin-1.6.0.js",
        authUrl: '/api/wechat/auth/js/token'
      }
    };
  }
  return sdkMap;
}

export default {
  /**
   * 准备阶段，加载环境sdk
   * @param opt
   * @returns {Promise<unknown>}
   */
  $ready(opt = {}) {
    let driveMap = opt?.driveList || _.values(driveList);
    let drive = _.find(driveMap, (d) => {
      return d?.isEnv();
    }) || {
      type: "web",
      init(res) {
        return Promise.resolve(res);
      },
    };
    this.$type = drive.type;
    dsf.mix(this, drive.methods);
    dsf.mix(this, { _onEventMappingNames: drive._onEventMappingNames || {} });
    return drive;
  },
  $driveList: driveList,
  $init(opt = {}) {
    let _opt = {
      driveList: [
        miniapp,
        GovDingTalk,
        DingTalk,
        Wechat,
        Harmony,
        Android,
        Ios,
        Native,
      ],
      ...getSdkMap(),
    };
    if (opt.driveList) {
      _opt.driveList = opt.driveList;
      delete opt.driveList;
    }
    dsf.mix(_opt, opt);
    let drive = this.$ready(_opt);
    this._register = this._register.bind(this)
    this._getFuncOpts = this._getFuncOpts.bind(this)
    this._errorMessage = this._errorMessage.bind(this)
    return drive.init(this._getFuncOpts({}, _opt), this, opt)
      .then((res) => {
        drive.$event = this.$event
        this.$inited = true;
        return res;
      });
  },
  $type: null,
  $inited: false,
  $event: new Event(),
  _getFuncOpts(def = {}, opt = {}) {
    let envOpt = {};
    if (dsf.type(opt) !== "object")
      throw "传入的参数需要是对象类型{xx:xx,_${env}:{xxx}}";
    for (const key in opt) {
      if (key.charAt(0, 1) !== "_") {
        envOpt[key] = opt[key];
      } else if (key == "_" + this.$type) {
        dsf.mix(envOpt, opt[key]);
      }
    }
    return dsf.mix(def, envOpt);
  },
  _errorMessage(funcDesc) {
    return `${this.$type}环境没有实现[${funcDesc}]方法`;
  },
  _register(keys, fn) {
    if (!keys) return;
    if (keys.indexOf(".") < 0) {
      this[keys] = fn.bind(this);
      return;
    }
    let keyMap = keys.split(".");
    let obj = this;
    let i = 0;
    while (i < keyMap.length) {
      let key = keyMap[i];
      if (!obj[key]) {
        obj[key] = {};
      } else {
        obj = obj[key];
      }
    }
    obj[keyMap[i]] = fn.bind(this);
  },

  /**
   * 下方为浏览器环境默认提供的方法
   *
   * 如果各端的js文件中没有重写下方声明的方法
   * 则会使用默认提供的方法兼容
   */

  /**
   * 选择图片
   * @returns {*}
   */
  chooseImage() {
    return dsf.file.load(".png,.jpg,.gif", true);
  },
  /**
   * 预览图片
   * @param options.current 当前显示图片的http链接
   * @param options.urls 需要预览的图片http链接列表
   * @returns {*}
   */
  previewImage() {
    return Promise.reject(this._errorMessage("预览图片"));
  },
  /**
   * 扫码
   * @param options.scanType 可以指定扫二维码还是一维码，默认二者都有
   * @returns {*}
   */
  scan() {
    return Promise.reject(this._errorMessage("扫一扫"));
  },
  /**
   * 获取地理位置接口
   * @param options.type 默认为wgs84的gps坐标
   */
  getLocation() {
    return Promise.reject(this._errorMessage("获取地位置"));
  },
  /**
   * 拨打电话
   * @param options
   * @param options.phoneNumber {string} 手机号码
   */
  callPhone(options = {}) {
    return new Promise((resolve, reject) => {
      try {
        if (!options.phoneNumber) throw "请传入phoneNumber电话号码";
        window.location.href = `tel:${options.phoneNumber}`;
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },
  makePhoneCall(opt) {
    return this.callPhone(opt);
  },
  // 新开页面
  open(opt = {}) {
    return new Promise((resolve, reject) => {
      let _opt = this._getFuncOpts(
        {
          url: "", // 网址
        },
        opt
      );
      if (!_opt.url) throw "请传入url";
      try {
        window.open(url);
      } catch (error) {
        reject(error);
      }
    });
  },
  // 设置 浏览器 title
  navigationSetTitle(opt = {}) {
    return new Promise((resolve, reject) => {
      try {
        let _opt = this._getFuncOpts(
          {
            title: "", // 网址
          },
          opt
        );
        window.document.title = _opt.title;
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },
  // 下载文件
  downloadFiles(opt = {}) {
    return new Promise((resolve, reject) => {
      try {
        if (dsf.type(opt.files) == "string") {
          opt.files = JSON.parse(opt.files);
        }
        let _opt = this._getFuncOpts(
          {
            files: [],
          },
          opt
        );
        if (!_opt.files.length) {
          console.warn("请传入opt.files");
          return reject("请传入opt.files");
        }
        let fileName = _opt.fileName;
        if (!fileName) {
          fileName = _opt.files[0].originalFileName;
        }
        let ids = _opt.files.map((ite) => ite.id).join(",");
        var url = dsf.url.getWebPath("file/download");
        url = url + "?files=" + ids + "&zipName=" + fileName;
        var url = dsf.url.getWebPath("file/download");
        $(
          '<form action="' +
            url +
            '" method="get">' + // action请求路径及推送方法
            '<input type="text" name="files" value="' +
            ids +
            '"/>' + // id^fileName
            '<input type="text" name="zipName" value="' +
            (fileName || "") +
            '"/>' + // 压缩包名称
            "</form>"
        )
          .appendTo("body")
          .submit()
          .remove();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },
};
